import { Component, OnInit, NgZone } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { WebSiteBase } from './web-site-base';
import { ManikEntityService } from '../manik-library/ManikEntityService';
import { ProcessMicroSite } from './editing-microsite-base';
import { NovaBookingHandler } from '../NovaBooking/nova-booking-handler';
import { CookieManager } from '../manik-library/ManikEntityFE';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { EcommBase } from '../models/ecomm-base';
import { map, take, retry } from 'rxjs/operators';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
declare const window: any;
declare const $: any;

@Component({
  selector: 'app-web-site',
  templateUrl: './web-site.component.html',
  styleUrls: ['./web-site.component.scss']
})

export class WebSiteComponent extends WebSiteBase implements OnInit {
  public oProcessMicroSite: ProcessMicroSite;
  public PreviewSite: string = "";
  private NovaBooking: NovaBookingHandler;
  SiteHtml: any;
  Interval: any;
  IsSiteLoadedInDOM: boolean = false;
  VisitorData: any = {};
  gRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';
  SiteEditType: string;

  constructor(public httpClient: HttpClient, public _manikEntityService: ManikEntityService,
    public _routeParams: ActivatedRoute, private zone: NgZone, protected title: Title, public _dialog: MatDialog) {
    super(httpClient, _routeParams, title, _manikEntityService);

    const headers = new Headers();
    headers.append('TenantID', 'INSTA.WEB');
    let options = new RequestOptions({ headers: headers });
  
      new EcommBase();
  
      this.oProcessMicroSite = new ProcessMicroSite(_manikEntityService);
      window.angularComponentRef = {
        zone: this.zone,
        componentFn: (value, action) => {
          this.BusinessID,
            this.PortalContext,
            this.BizHandle,
            this.PortalDS,
            this.BackendURL,
            this.StoreHandle,
            this.ManageCart(value, action),
            this.Local_EventOnFilterChange(value, action),
            this.PopulateProductDetails(value),
            this.BookResource(value),
            this.OnDemandDivArray,
            this.HandleBookingCalendar(value, action),
            this.DrawBookingSupportingEffect(value),
            this.Checkout(),
            this.ProductList,
            this.VarientList,
            this.oProcessMicroSite,
            // this.PublishMicrosite(),
            this.FileUploadChange(value),
            this.SiteEditType,
            // this.OpenEditDialog(),
            this.VerfiyCaptch(value, action),
            this.ManikUploadedFile1,
            this.ManikUploadedFileName1,
            this.ManikUploadedFile2,
            this.ManikUploadedFileName2,
            this.ManikUploadedFile3,
            this.ManikUploadedFileName3,
            this.ManikUploadedFile4,
            this.ManikUploadedFileName4
        },
        component: this
      };
      this.populateControls();
      this.NovaBooking = new NovaBookingHandler(_manikEntityService, this.document);
    }

  ngOnInit() {
    this.PreviewSite = location.origin + "/" + this._routeParams.snapshot.params['businessslug'];
    console.log('PreviewSitePreviewSite',this.PreviewSite);
    
    this.Interval = setInterval(() => {
      this.SiteHtml = this.SiteMetaData;
      console.log("zxvb",this.SiteMetaData);
      
      if (this.IsWebPageInitialized) {
        clearInterval(this.Interval);
        this.IsSiteLoadedInDOM = true;
      }
    }, 10);

  }

  SubmitEnquiryForm(body: any) {
    $("#iEnquiryFailure").hide();
    $("#iEnquirySuccess").hide();
    let IP = "";
    // this._manikEntityService.manikGetMyIPAddress()
    //   .subscribe(IP => {
    //body["BusinessHandle"] = this.WebSiteMetaData["BizHandle"];
    let attachements;
    let uploadUrl = this._manikEntityService.uploadURL;
    if (this.ManikUploadedFile1) {
      attachements = {
        "ItemName": "Image",
        "ItemValue": (this.ManikUploadedFileName1[0]) ? uploadUrl + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]).toLowerCase() : ''
      };
      body.push(attachements);
    }
    if (this.ManikUploadedFile2) {
      attachements = {
        "ItemName": "Image",
        "ItemValue": (this.ManikUploadedFileName2[0]) ? uploadUrl + this.manikGetFileExtFromName(this.ManikUploadedFileName2[0]).toLowerCase() : ''
      };
      body.push(attachements);
    }
    if (this.ManikUploadedFile3) {
      attachements = {
        "ItemName": "Image",
        "ItemValue": (this.ManikUploadedFileName3[0]) ? uploadUrl + this.manikGetFileExtFromName(this.ManikUploadedFileName3[0]).toLowerCase() : ''
      };
      body.push(attachements);
    }
    if (this.ManikUploadedFile4) {
      attachements = {
        "ItemName": "Image",
        "ItemValue": (this.ManikUploadedFileName4[0]) ? uploadUrl + this.manikGetFileExtFromName(this.ManikUploadedFileName4[0]).toLowerCase() : ''
      };
      body.push(attachements);
    }

    for (let i = 0; i < body.length; i++) {
      // body[i]["BusinessID"] = this.WebSiteMetaData["BID"];
      body[i]["BusinessHandle"] = this.WebSiteMetaData["BizHandle"];
      body[i]["IPAddress"] = "10.10.01.11";//IP; 
    }

    this._manikEntityService.manikEntityConnect2(this.EndPoint + "entitymgr", JSON.stringify({ "items": body }),
      this.prepareManageHeaders2("A", "BUSINESS.ENQUIRY", "BIZ"))
      .subscribe(data => {
        let resp: any = data;
        if (resp) {
          $("#iEnquirySuccess").show();
        } else {
          $("#iEnquiryFailure").show();
        }
        let path: string = "http://resources.manikworks.com/enquiry/docupload/4b12530d-a209-49da-9eca-245d1169f41c/100210";//data.ManikJSon[0].JSon0[0].SavePath;
        let fileName: string = "test";//data.ManikJSon[0].JSon0[0].FileName;
        if (this.ManikUploadedFile1) {
          this._manikEntityService.manikImageUpload(this.ManikUploadedFile1,
            this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName1[0]), "", "", "user_data"))
            .subscribe(success => success);
        }
        if (this.ManikUploadedFile2) {
          this._manikEntityService.manikImageUpload(this.ManikUploadedFile2,
            this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName2[0]), "", "", "user_data"))
            .subscribe(success => success);
        }
        if (this.ManikUploadedFile3) {
          this._manikEntityService.manikImageUpload(this.ManikUploadedFile3,
            this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName3[0]), "", "", "user_data"))
            .subscribe(success => success);
        }
        if (this.ManikUploadedFile4) {
          this._manikEntityService.manikImageUpload(this.ManikUploadedFile4,
            this.prepareImageUploadHeader(path, fileName + '.' + this.manikGetFileExtFromName(this.ManikUploadedFileName4[0]), "", "", "user_data"))
            .subscribe(success => success);
        }
      });
  }

  PublishMicrosite() {
    this.oProcessMicroSite.Interval = setInterval(() => {
      if (this.oProcessMicroSite.ProcessingText === "Processing...") {
        this.oProcessMicroSite.ProcessingText = "Processing.";
      }
      else if (this.oProcessMicroSite.ProcessingText === "Processing..") {
        this.oProcessMicroSite.ProcessingText = "Processing...";
      }
      else if (this.oProcessMicroSite.ProcessingText === "Processing.") {
        this.oProcessMicroSite.ProcessingText = "Processing..";
      }
    }, 300);
    this.oProcessMicroSite.IsProcessing = true;
    this.oProcessMicroSite.PublishMicroSite(this._routeParams.snapshot.params['businessslug'], this.PortalContext);
  }

  OpenEditDialog() {
    this.SiteEditOptions = {
      Type: this.SiteEditType,
      BusinessHandle: this.BizHandle,
      BusinessID: this.BusinessID,
      PortalContext: this.PortalContext,
      PortalDS: this.PortalDS
    };

    this._manikEntityService.setData(this.SiteEditOptions);

    //this.IsEditOptionPopulated = true;
    // const dialogRef = this._dialog.open(SiteEditComponent);
    // dialogRef.componentInstance.EditOption = this.SiteEditOptions;
    // dialogRef.afterClosed().subscribe(result => {
    // });
  }

  ResetBackgrounds(): void {
    this.oProcessMicroSite.ResetBackgrounds(this._routeParams.snapshot.params['businessslug'], this.PortalContext);
  }

  ManageCart(product, action): void {
    // this.NovaEcomm = new ManikEcommBase(this.httpClient);
    switch (action) {
      case "A":
        this.NovaEcomm.Local_CartSmartManagePlus(product);
        break;
      case "R":
        this.NovaEcomm.Local_CartSmartManageMinus(product, action);
        break;
      case "D":
        this.NovaEcomm.Local_CartSmartManageMinus(product, action);
        break;
      default:
        this.NovaEcomm.Local_Cart_View();
        break;
    }
  }

  SelectSummaryDiv(source) {
    $('#iManikEcommSummary').hide();
    $('#iManikBookingSummary').hide();
    switch (source) {
      case 'ECOMM':
        $('#iManikEcommSummary').show();
        break;
      case 'BOOKING':
        $('#iManikBookingSummary').show();
        break;
    }
  }

  PopulateProductDetails(ProductHandle: string) {
    //this.NovaEcomm.PopulateProductDetails(this.StoreHandle, ProductHandle);
  }

  Local_EventOnFilterChange(CategoryID: string = "", Type: string = "") {
    this.NovaEcomm.Local_EventOnFilterChange(this.StoreHandle, CategoryID, Type);
  }

  public PatymPayments(): void {
    this._manikEntityService.manikWebAPIConnect("WebSite/Paytm/initializepayment", null, null).
      subscribe(data => {
        //console.log(data);
      });
    // this._manikEntityService.manikEntityConnect2("WebSite/Paytm", null, null)
    //   .subscribe(data => {
    //     this.SiteHtml = data.Response;
    //     setTimeout(() => {
    //       this.document.f1.submit();
    //     }, 50);
    //     //this.SiteMetaData = data.Response;
    //     console.log(data);
    //   });
  }

  Checkout() {
    this.NovaEcomm.API_Checkout();
  }

  BookResource(PostedData: any) {
    PostedData["BuyerHandle"] = JSON.parse(sessionStorage.getItem("UserData")).BuyerHandle;
    this.BookingStore.SubmitBookingRequest(PostedData);
  }

  HandleBookingCalendar(val, action) {
    switch (action) {
      case 'NEXT':
        this.NovaBooking.OnClickNext();
        break;
      case 'PREV':
        this.NovaBooking.OnClickPrevious();
        break;
      case 'DATE':
        this.NovaBooking.OnClickDate(val[0]);
        break;
      case 'SLOT':
        if (val) this.NovaBooking.OnClickSlot(val[0], val[1]);
        break;
    }
  }

  DrawBookingSupportingEffect(val) {
    this.NovaBooking.DrawSupportingEffect(val);
  }

  VisitorLoggedIn() {
    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      this.VisitorData = x;
      // console.log(x);
    }
  }

  VerfiyCaptch(token: string, body: any) {
    let headers = { headers: null };
    let StoreInfo = this.httpClient.post<any>(this.AppRootUrl + "WebSite/captcha/v3?sToken=" + token, null, headers).pipe(map(value => value), take(1), retry(3));
    StoreInfo.subscribe(data => {
      if (data.success)
        this.SubmitEnquiryForm(body);
    });
  }
}
